import { isSSR } from "./rendering"

export const getCookie = (cookieName: string) => {
    if (isSSR()) return undefined

    const rawCookie = window.document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${cookieName}=`))
        ?.split("=")[1]

    if (!rawCookie) return undefined
    try {
        return decodeURIComponent(rawCookie)
    } catch (e) {
        console.error("unable to parse cookie", e)
        return undefined
    }
}

type CookieOptions = {
    domain?: string
    sameSite?: "strict" | "lax" | "none"
    maxAge?: number
    path?: string
}
export const setCookie = (cookieName: string, value: string, options: CookieOptions = {}) => {
    if (isSSR()) return
    const { domain = cookieDomain(window.location.hostname), sameSite, maxAge, path } = options
    const cookie = [
        `${cookieName}=${value}`,
        domain ? `domain=${domain}` : undefined,
        `samesite=${sameSite ?? "strict"}`,
        `path=${path ?? "/"}`,
        maxAge ? `max-age=${maxAge}` : undefined,
    ]
        .filter((x) => x !== undefined)
        .join("; ")

    window.document.cookie = cookie
}

export const deleteCookie = (cookieName: string) => setCookie(cookieName, "", { maxAge: -1 })

export const cookieDomain = (domain: string) => {
    const levels = domain.split(".")
    const keepAtLeastTwoLevels = Math.min(1 - levels.length, -2)
    return levels.slice(keepAtLeastTwoLevels).join(".")
}
